import { useState, useEffect } from 'react';
import { Modal } from '../ui/Modal';
import { Button } from '../ui/Button';
import { ConsentCheckbox } from '../legal/ConsentCheckbox';
import { getRequiredAtPayment, recordConsent } from '../../api/legal';

export function PreCheckoutModal({ open, onClose, onConfirm, planLabel, totalAmount }) {
  const [docs, setDocs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [checked, setChecked] = useState({});
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!open) return;
    setError('');
    setChecked({});
    setLoading(true);
    getRequiredAtPayment()
      .then(d => setDocs(d.documents || []))
      .catch(() => {
        setDocs([]);
        // Hata yutma — kullanıcı yine de ödeme yapabilsin
      })
      .finally(() => setLoading(false));
  }, [open]);

  // Loading bittikten sonra: docs varsa hepsi işaretli mi, yoksa direkt true
  const allChecked = !loading && (docs.length === 0 || docs.every(d => checked[d.slug]));

  const handleConfirm = async () => {
    if (!allChecked) return;
    setSaving(true);
    setError('');
    try {
      let lastConsentId = null;
      for (const doc of docs) {
        const r = await recordConsent({
          document_id: doc.id,
          context: 'payment',
        });
        lastConsentId = r.consent.id;
      }
      onConfirm(lastConsentId);
    } catch (err) {
      setError('Onay kaydedilemedi. Lütfen tekrar deneyin.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal open={open} onClose={onClose} title="Ödeme Onayı" size="md">
      <div className="bg-slate-50 rounded-lg p-4 mb-5">
        <div className="flex justify-between text-sm mb-1">
          <span className="text-slate-600">Plan:</span>
          <span className="font-semibold text-slate-800">{planLabel}</span>
        </div>
        <div className="flex justify-between text-base">
          <span className="text-slate-700 font-medium">Toplam:</span>
          <span className="font-bold text-slate-900">
            {new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY' }).format(totalAmount)}
          </span>
        </div>
      </div>

      {loading ? (
        <p className="text-sm text-slate-500 mb-6">Sözleşmeler yükleniyor...</p>
      ) : docs.length > 0 ? (
        <div className="space-y-3 mb-6">
          {docs.map(doc => (
            <ConsentCheckbox
              key={doc.slug}
              document={doc}
              checked={!!checked[doc.slug]}
              onChange={(v) => setChecked(prev => ({ ...prev, [doc.slug]: v }))}
            />
          ))}
        </div>
      ) : (
        <div className="bg-blue-50 border border-blue-200 text-blue-800 text-sm rounded-lg p-3 mb-6">
          Sözleşmeler henüz hazırlanmaktadır. Şu an direkt ödemeye geçebilirsiniz.
        </div>
      )}

      {error && (
        <div className="bg-red-50 border border-red-200 text-red-700 text-sm rounded-lg p-3 mb-4">
          {error}
        </div>
      )}

      <div className="flex justify-end gap-2">
        <Button variant="secondary" onClick={onClose}>Vazgeç</Button>
        <Button onClick={handleConfirm} disabled={!allChecked} loading={saving}>
          Ödemeye Geç
        </Button>
      </div>
    </Modal>
  );
}